/*jshint esversion: 6 */
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import { useBlockProps } from '@wordpress/block-editor';

import { useState } from '@wordpress/element';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import '../tec-slider-editor.js';
import TecSliderBlock from './tec-slider-block.js';

const {
    RichText,
    AlignmentToolbar,
    BlockControls,
    BlockAlignmentToolbar,
    InspectorControls,
} = wp.editor;
const {
    Button,
    ButtonGroup,
    ToggleControl,
    PanelBody,
    PanelRow,
    ColorPicker,
    SelectControl,
    BaseControl,
    Disabled,
    RangeControl
} = wp.components;
const { Fragment } = wp.element;


import { useSelect } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';

import React from 'react';
import Select from 'react-select';

import CustomFontSelect from './custom-font-select';
import { fontOptions } from './fonts.js';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({ attributes, setAttributes, clientId }) {
    const {
        sliderTheme,
        sliderType,
        eventInRow,
        eventInSlide,
        autoplay,
        transitionDelay,
        colorScheme,
        blockId,
        customSelectedEvents,
        newtab,
        category,
        plugin,
        countdownTimer,
        dots,
        darkmode,
        slideHeight,
        slideTopHeight,
        imageHeight
    } = attributes;
    const setSliderColor = color => {
        setAttributes( { colorScheme: color } );
    };
    if ( ! blockId || '' === blockId ) {
        setAttributes( { blockId: 'tec-slider-block-' + clientId } );
    }
    //const [color, setColor] = useState();
    const blockProps = useBlockProps();
    let options = [];
    const typesarr = [
        {
            'label' : __( 'Upcoming Events', 'tecslider' ),
            'value' : 'upcoming'
        },
        {
            'label' : __( 'Past Events', 'tecslider' ),
            'value' : 'past',
        },
        {
            'label' : __( 'Custom Events', 'tecslider' ),
            'value' : 'custom',
        },
    ];
    let types = [];
    for (const type of typesarr) {
        types.push({
            label : type.label,
            value : type.value
        });
    }

    const events = useSelect(
        (select) => select(coreStore).getEntityRecords( 'postType', 'tribe_events' ), []
    );
    var eventsOptions = !Array.isArray(events) ? events : events
        .map(
            // Format the options for display in the <SelectControl/>
            (events) => ({
                label: events.title.rendered,
                value: events.slug, // the value saved as events in attributes
            })
    );
    const handleCustomEventChange = ( customSelectedEvents ) => setAttributes( { customSelectedEvents: JSON.stringify( customSelectedEvents ) } );

    const { titleFontFace, titleFontSize, descFontFace, descFontSize, datetimeFontFace, datetimeFontSize } = attributes;

    // Function to update font
    const onChangeFontFace = (selectedOption) => {
        setAttributes({ titleFontFace: selectedOption.value });
    };
    const onChangeFontSize = (selectedOption) => {
        setAttributes({ titleFontSize: selectedOption });
    };
    const onChangeDTFontFace = (selectedOption) => {
        setAttributes({ datetimeFontFace: selectedOption.value });
    };
    const onChangeDTFontSize = (selectedOption) => {
        setAttributes({ datetimeFontSize: selectedOption });
    };
    const onChangeFontFaceDesc = (selectedOption) => {
        setAttributes({ descFontFace: selectedOption.value });
    };
    const onChangeFontSizeDesc = (selectedOption) => {
        setAttributes({ descFontSize: selectedOption });
    };
    const onSlideHeightChange = newHeight => {
        setAttributes({ slideHeight: newHeight });
    };
    const onImageHeightChange = newHeight => {
        setAttributes({ imageHeight: newHeight });
    };
    const is_premium = tecsliderIsPremium;
    const premiumText = ! is_premium ? __( ' (Premium)', 'tecslider') : '';
    const premiumOptions = [
        { label: __( 'Image Middle', 'tecslider' ) + premiumText, value: 'imagemiddle', disabled: ! is_premium },
        { label: __( 'Over Image', 'tecslider' ) + premiumText, value: 'overimage', disabled: ! is_premium },
        { label: __( 'Hover Detail', 'tecslider' ) + premiumText, value: 'hoverdetail', disabled: ! is_premium },
        { label: __( 'Flip on Hover', 'tecslider' ) + premiumText, value: 'hoverflip', disabled: ! is_premium },
        { label: __( 'Card Layout', 'tecslider' ) + premiumText, value: 'cardlayout', disabled: ! is_premium },
        { label: __( 'Split Layout', 'tecslider' ) + premiumText, value: 'splitlayout', disabled: ! is_premium },
    ];

    //const optionsToShow = is_premium ? premiumOptions : [];
    const optionsToShow = premiumOptions;
    const allOptions = [
        { label: __( 'Date Top', 'tecslider' ), value: 'datetop', disabled: false },
        { label: __( 'Colored Card', 'tecslider' ), value: 'coloredcard', disabled: false },
        { label: __( 'Single Event', 'tecslider' ), value: 'singleevent', disabled: false},
        { label: __( 'Date Focus', 'tecslider' ), value: 'datefocus', disabled: false},
        ...optionsToShow,
    ];
    return (
    <div { ...useBlockProps() }>
        <Fragment>
            <InspectorControls key="setting">
                <PanelBody
                    title={ __( 'Slider settings', 'tecslider' ) }
                    className="tecslider-controls tecslider-controls-general eedee-icon-panel"
                >
                    <PanelRow>
                        <BaseControl help={ __( 'Choose slider event(s) type', 'tecslider' ) }>
                            <BaseControl.VisualLabel>{ __( 'Event Type', 'tecslider' ) }</BaseControl.VisualLabel>
                            <ButtonGroup aria-label={ __( 'Upcoming Event(s)', 'tecslider' ) } className="tecslider-toggle-slider-type">
                                <Button
                                    isSecondary={ sliderType !== 'upcoming' }
                                    isPrimary={ sliderType === 'upcoming' }
                                    aria-pressed={ sliderType === 'upcoming' }
                                    onClick={ () => {
                                        setAttributes( { sliderType: 'upcoming' } );
                                        
                                    } }
                                >
                                    { __( 'Upcoming', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ sliderType !== 'past' }
                                    isPrimary={ sliderType === 'past' }
                                    aria-pressed={ sliderType === 'past' }
                                    onClick={ () => {
                                        setAttributes( { sliderType: 'past' } );
                                        
                                    } }
                                >
                                { __( 'Past', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ sliderType !== 'custom' }
                                    isPrimary={ sliderType === 'custom' }
                                    aria-pressed={ sliderType === 'custom' }
                                    onClick={ () => {
                                        setAttributes( { sliderType: 'custom' } );
                                        
                                    } }
                                    disabled={! is_premium}
                                >
                                { __( 'Custom', 'tecslider' ) }
                                </Button>
                                {/* {is_premium &&} */}
                            </ButtonGroup>
                        </BaseControl>
                    </PanelRow>
                    <PanelRow>
                        <SelectControl
                            label={ __('Select Theme', 'tecslider') }
                            value={ sliderTheme }
                            options={ allOptions }
                            onChange={ ( val ) => {
                                setAttributes( {sliderTheme: val} );
                                
                            } }
                        />
                    </PanelRow>
                    <PanelRow>
                        <div class="tec-flex-container">
                            <div className="tec-label">
                                <label htmlFor="font-select">
                                    { __( 'DateTime/Location/Organizer Font', 'tecslider' ) }
                                </label>
                            </div>
                            <Select
                                value={{ value: datetimeFontFace, label: datetimeFontFace }}
                                options={fontOptions}
                                onChange={onChangeDTFontFace}
                                className="full-width-select"
                                styles={{
                                    option: (provided, state) => ({
                                        ...provided,
                                        fontFamily: state.data.value, // Apply font face style
                                    }),
                                }}
                            />
                        </div>
                    </PanelRow>
                    <PanelRow>
                        <RangeControl
                            label={__('DateTime/Location/Organizer Font Size', 'tecslider')}
                            value={datetimeFontSize}
                            onChange={onChangeDTFontSize}
                            min={-10}
                            max={10}
                            withInputField={false}
                        />
                    </PanelRow>
                    <PanelRow>
                        <div class="tec-flex-container">
                            <div className="tec-label">
                                <label htmlFor="font-select">
                                    { __( 'Title Font', 'tecslider' ) }
                                </label>
                            </div>
                            <Select
                                value={{ value: titleFontFace, label: titleFontFace }}
                                options={fontOptions}
                                onChange={onChangeFontFace}
                                className="full-width-select"
                                styles={{
                                    option: (provided, state) => ({
                                        ...provided,
                                        fontFamily: state.data.value, // Apply font face style
                                    }),
                                }}
                            />
                        </div>
                    </PanelRow>
                    <PanelRow>
                        <RangeControl
                            label={__('Title Font Size', 'tecslider')}
                            value={titleFontSize}
                            onChange={onChangeFontSize}
                            min={12}
                            max={36}
                            withInputField={false}
                        />
                    </PanelRow>
                    <PanelRow>
                        <div class="tec-flex-container">
                            <div className="tec-label">
                                <label htmlFor="font-select">
                                    { __( 'Description Font', 'tecslider' ) }
                                </label>
                            </div>
                            <Select
                                value={{ value: descFontFace, label: descFontFace }}
                                options={fontOptions}
                                onChange={onChangeFontFaceDesc}
                                className="full-width-select"
                                styles={{
                                    option: (provided, state) => ({
                                        ...provided,
                                        fontFamily: state.data.value, // Apply font face style
                                    }),
                                }}
                            />
                        </div>
                    </PanelRow>
                    <PanelRow>
                        <RangeControl
                            label={__('Description Font Size', 'tecslider')}
                            value={descFontSize}
                            onChange={onChangeFontSizeDesc}
                            min={8}
                            max={26}
                            withInputField={false}
                        />
                    </PanelRow>
                    {'custom' === sliderType &&
                        <PanelRow className="tecslider-right-panel-cevent">
                            <BaseControl.VisualLabel className="tecslider-rp-label">{ __( 'Event(s) for Slider', 'tecslider' ) }</BaseControl.VisualLabel>
                            <BaseControl help={ __( 'Choose event(s) for slider ( Upcoming only )', 'tecslider' ) }>
                                <Select
                                    name='custom-events'
                                    label= { __( "Select an event", 'tecslider' ) }
                                    value={ JSON.parse( customSelectedEvents ) }
                                    onChange={ handleCustomEventChange }
                                    options={eventsOptions}
                                    isMulti='true'
                                />
                            </BaseControl>
                        </PanelRow>
                    }
                    {'singleevent' !== sliderTheme &&
                    <PanelRow>
                        <BaseControl help={ __( 'Choose no of event(s) in row', 'tecslider' ) }>
                            <BaseControl.VisualLabel>{ __( 'Event Count', 'tecslider' ) }</BaseControl.VisualLabel>
                            <ButtonGroup aria-label={ __( '1', 'tecslider' ) } className="tecslider-toggle-event-in-row">
                                <Button
                                    isSecondary={ eventInRow !== 1 }
                                    isPrimary={ eventInRow === 1 }
                                    aria-pressed={ eventInRow === 1 }
                                    onClick={ () => {
                                        setAttributes( { eventInRow: 1 } );
                                        
                                    } }
                                >
                                    { __( '1', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ eventInRow !== 2 }
                                    isPrimary={ eventInRow === 2 }
                                    aria-pressed={ eventInRow === 2 }
                                    onClick={ () => {
                                        setAttributes( { eventInRow: 2 } );
                                        
                                    } }
                                >
                                { __( '2', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ eventInRow !== 3 }
                                    isPrimary={ eventInRow === 3 }
                                    aria-pressed={ eventInRow === 3 }
                                    onClick={ () => {
                                        setAttributes( { eventInRow: 3 } );
                                        
                                    } }
                                >
                                { __( '3', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ eventInRow !== 4 }
                                    isPrimary={ eventInRow === 4 }
                                    aria-pressed={ eventInRow === 4 }
                                    onClick={ () => {
                                        setAttributes( { eventInRow: 4 } );
                                        
                                    } }
                                >
                                { __( '4', 'tecslider' ) }
                                </Button>
                            </ButtonGroup>
                        </BaseControl>
                    </PanelRow>
                    }
                    {'singleevent' !== sliderTheme &&
                    <PanelRow>
                        <BaseControl help={ __( 'Choose no of event(s) to slide', 'tecslider' ) }>
                            <BaseControl.VisualLabel>{ __( 'Event(s) on Slide', 'tecslider' ) }</BaseControl.VisualLabel>
                            <ButtonGroup aria-label={ __( '1', 'tecslider' ) } className="tecslider-toggle-event-in-slide">
                                <Button
                                    isSecondary={ eventInSlide !== 1 }
                                    isPrimary={ eventInSlide === 1 }
                                    aria-pressed={ eventInSlide === 1 }
                                    onClick={ () => {
                                        setAttributes( { eventInSlide: 1 } );
                                        
                                    } }
                                >
                                    { __( '1', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ eventInSlide !== 2 }
                                    isPrimary={ eventInSlide === 2 }
                                    aria-pressed={ eventInSlide === 2 }
                                    onClick={ () => {
                                        setAttributes( { eventInSlide: 2 } );
                                        
                                    } }
                                >
                                { __( '2', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ eventInSlide !== 3 }
                                    isPrimary={ eventInSlide === 3 }
                                    aria-pressed={ eventInSlide === 3 }
                                    onClick={ () => {
                                        setAttributes( { eventInSlide: 3 } );
                                        
                                    } }
                                >
                                { __( '3', 'tecslider' ) }
                                </Button>
                                <Button
                                    isSecondary={ eventInSlide !== 4 }
                                    isPrimary={ eventInSlide === 4 }
                                    aria-pressed={ eventInSlide === 4 }
                                    onClick={ () => {
                                        setAttributes( { eventInSlide: 4 } );
                                        
                                    } }
                                >
                                { __( '4', 'tecslider' ) }
                                </Button>
                            </ButtonGroup>
                        </BaseControl>
                    </PanelRow>
                    }
                    {/* { is_premium && } */}
                    <ToggleControl
                        label={
                            <>
                            { __( 'Enable Countdown Timer', 'tecslider' ) }
                            {! is_premium && <span className="mwt-premium-badge" style={{display: 'inline-block'}}>{__('Premium', 'tecslider')}</span>}
                            </>
                            }
                        checked={ countdownTimer }
                        onChange={ ( val ) => {
                            setAttributes( {
                                countdownTimer: val,
                            } );
                        } }
                        disabled={! is_premium}
                    />
                    <ToggleControl
                        label={ __( 'Auto start and slide', 'tecslider' ) }
                        checked={ autoplay }
                        onChange={ ( val ) => {
                            setAttributes( {
                                autoplay: val,
                            } );
                            
                        } }
                    />
                    <ToggleControl
                        label={
                            <>
                            { __( 'Enable Dots', 'tecslider' ) }
                            {! is_premium && <span className="mwt-premium-badge" style={{display: 'inline-block'}}>{__('Premium', 'tecslider')}</span>}
                            </>
                            }
                        checked={ dots }
                        onChange={ ( val ) => {
                            setAttributes( {
                                dots: val,
                            } );
                            
                        } }
                        disabled={! is_premium}
                    />
                    <ToggleControl
                        label={ __( 'Open event in new tab', 'tecslider' ) }
                        checked={ newtab }
                        onChange={ ( val ) => {
                            setAttributes( {
                                newtab: val,
                            } );
                            
                        } }
                    />
                    {
                        (
                            'coloredcard' !== sliderTheme
                        ) && (
                        <ToggleControl
                            label=
                                {
                                <>
                                { __( 'Enable Dark Mode', 'tecslider' ) }
                                {! is_premium && <span className="mwt-premium-badge" style={{display: 'inline-block'}}>{__('Premium', 'tecslider')}</span>}
                                </>
                                }
                            checked={ darkmode }
                            onChange={ ( val ) => {
                                setAttributes( {
                                    darkmode: val,
                                } );
                                
                            } }
                            disabled={! is_premium}
                        />
                    )}
                    {eventCategoriesData.length > 0 && (
                    <SelectControl
                        label="Select Event Category"
                        value={category}
                        options={eventCategoriesData.map(category => ({
                            label: category.name,
                            value: category.slug,
                        }))}
                        onChange={(value) => setAttributes({ category: value })}
                    />
                    )}
                    <SelectControl
                        label={ __('Transition Delay (in ms.)', 'tecslider') }
                        value={ transitionDelay }
                        options={ [
                            { label: '200', value: '200' },
                            { label: '400', value: '400' },
                            { label: '600', value: '600' },
                            { label: '800', value: '800' },
                            { label: '1000', value: '1000' },
                        ] }
                        onChange={ ( val ) => {
                            setAttributes( {transitionDelay: val} );
                            
                        } }
                    />
                    {
                        (
                        sliderTheme !== 'hoverflip'
                        &&
                        sliderTheme !== 'hoverdetail'
                        )
                        && (
                    <PanelRow>
                        <RangeControl
                            label={__('Slider Detail Height', 'tecslider')}
                            value={slideHeight}
                            onChange={onSlideHeightChange}
                            min={100}
                            max={600}
                            step={10}
                            withInputField={false}
                        />
                    </PanelRow>
                    )}
                    {
                        (
                        sliderTheme !== 'hoverdetail'
                        &&
                        sliderTheme !== 'hoverflip'
                        )
                        && (
                    <PanelRow>
                        <RangeControl
                            label={__('Image Height', 'tecslider')}
                            value={imageHeight}
                            onChange={onImageHeightChange}
                            min={100}
                            max={600}
                            step={10}
                            withInputField={false}
                        />
                    </PanelRow>
                    )}
                    {
                        (
                        sliderTheme !== 'overimage'
                        &&
                        sliderTheme !== 'hoverdetail'
                        )
                        && (
                    <PanelRow>
                        <BaseControl help={ __( 'Choose color', 'tecslider' ) }>
                            <BaseControl.VisualLabel>{ __( 'Slider Color', 'tecslider' ) }</BaseControl.VisualLabel>
                                <ColorPicker
                                    color={colorScheme}
                                    onChangeComplete={ ( colorScheme ) => {
                                        setSliderColor( colorScheme.hex );
                                        
                                    } }
                                    enableAlpha
                                    defaultValue="#5a30f3"
                                />
                        </BaseControl>
                    </PanelRow>
                    )}
                </PanelBody>
            </InspectorControls>
        </Fragment>
        <TecSliderBlock
            options={attributes}
        />
    </div>
    );
}
